// Placeholder ("for position only") artwork.
//
// The brand artwork now ships with the bundle, so this covers only the two images
// that do not exist yet — both of which are placeholders in the Figma file too:
//
//   - the hero video poster (Figma 421:11 is a screenshot standing in for it)
//   - the "Meet the artist" photo (Figma 421:25 is literally labelled FPO)
//
// Each is sized to the exact Figma geometry so the layout does not shift when the
// real image arrives. Swapping one in means either passing the matching attribute
// (`poster`, `photo`) or dropping the file next to the component and importing it —
// Vite inlines it as a base64 data URL, keeping the bundle self-contained.

/**
 * A neutral grey box with a label and the intended dimensions, returned as a
 * data URI so it costs no network request and no separate asset file.
 */
export function fpo(width: number, height: number, label = "FPO"): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" role="img" aria-hidden="true">
  <rect width="${width}" height="${height}" fill="#d9d9d9"/>
  <path d="M0 0 L${width} ${height} M${width} 0 L0 ${height}" stroke="#c4c4c4" stroke-width="1" fill="none"/>
  <text x="50%" y="50%" fill="#8a8a8a" font-family="system-ui, sans-serif" font-size="${Math.max(11, Math.min(width, height) * 0.12)}" font-weight="700" text-anchor="middle" dominant-baseline="middle">${label}</text>
</svg>`;

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
